import { replacePrismicObject } from '@swegaming-ab/nuxtjs-helpers';

export default ({ app }, inject) => {
    const cardShortcodes = (document, model) => ({
        'card': document.data.title,
        'maxCredit': model.getMaxCreditString(app.$translate('no_max_credit', 'Ingen kreditgräns')),
        'interest': model.interestString,
        'minInterest': model.minInterestPossibleString,
        'maxInterest': model.maxInterestPossibleString,
        'effectiveInterest': model.effectiveInterestString,
        'minEffectiveInterest': model.minEffectiveInterestPossibleString,
        'maxEffectiveInterest': model.maxEffectiveInterestPossibleString,
        'yearlyCost': model.yearlyCostString,
        'interestFreeDays': model.getInterestFreeDaysString(app.$translate('core_models_rate_free_days', '{days} dagar'))
    });

    const resolveCardDocument = (cardDocument) => {
        if (!cardDocument?.id || cardDocument.type !== 'credit_card') {
            return null;
        }

        const card = cardDocument.data
            ? cardDocument
            : app.store.state.cards[cardDocument.id];

        if (!card) {
            return null;
        }

        return {
            document: card,
            model: new app.$models.CreditCard(card)
        };
    };

    inject('replaceCardShortcodes', (text, cardDocument, selectedShortcodes) => {
        if (!app.$validateText(text)) {
            return text;
        }

        const cardWithModel = resolveCardDocument(cardDocument);
        if (!cardWithModel) {
            return text;
        }

        const shortcodes = cardShortcodes(cardWithModel.document, cardWithModel.model);

        const activeShortcodes = selectedShortcodes
            ? Object.entries(shortcodes).filter(([key]) => selectedShortcodes.includes(key))
            : Object.entries(shortcodes);

        const replace = (str) => {
            let result = str;
            for (const [shortcode, value] of activeShortcodes) {
                result = result.replaceAll(`{${shortcode}}`, String(value ?? ''));
            }
            return result;
        };

        if (Array.isArray(text)) {
            const clonedText = JSON.parse(JSON.stringify(text));
            for (const [shortcode, value] of activeShortcodes) {
                replacePrismicObject(clonedText, `{${shortcode}}`, String(value ?? ''));
            }
            return clonedText;
        }

        return replace(text);
    });
};
